import React           from 'react';
import { generateKey } from '../../../utils/CommonUtils';
import Translations    from '../../../utils/Translations';

const ActorProfileBadges = (props) => {

    const { isLivePreviewEnabled, isChatQualityHD, isStar, spokenLanguages } = props;

    const languageBadges = spokenLanguages?.map((language, idx) => {
        return <span key={generateKey('lng-badge', idx)} className={`badge-language -lang-${language} h-left`}/>
    });

    return (
        <div className='actor-profile-header__badges'>

            {isLivePreviewEnabled && <span className='badge--normal h-left'>{Translations.get('actor_profile.header-badge.livepreview')}</span>}
            {isChatQualityHD && <span className='badge--normal h-left'>{Translations.get('actor_profile.header-badge.hd')}</span>}
            {isStar && <span className='badge--highlight h-left'>{Translations.get('actor_profile.header-badge.star')}</span>}

            {languageBadges}
        </div>
    )
}

export default ActorProfileBadges
